import React, { useEffect, useState } from "react";
import { UpdateFieldFn, Golfer } from "../types/types";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./shared/Footer";
import {
  normalizeInput,
  formatDOB,
  convertFromISOToUS,
  isValidDOB,
  usDateToTimestamp,
} from "../utils/utils";
import {
  getProducts,
  createOrUpdateMember,
  createMember,
  createGiftPurchase,
} from "../api/api-hook";

interface Step3Props {
  formData: Golfer;
  updateField: UpdateFieldFn;
  resetFormData: () => void;
}

interface LocationState {
  golfer?: Golfer;
}

const Confirm: React.FC<Step3Props> = ({
  formData,
  updateField,
  resetFormData,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const state = (location.state || {}) as LocationState;
  const [sameAsBilling, setSameAsBilling] = useState<boolean>(true);

  // Refresh-safe fallback:
  // 1. use location.state.golfer when arriving from navigate(...)
  // 2. fall back to formData on page refresh
  const golfer: Golfer | null = state.golfer ?? (formData || null);

  console.log(golfer);

  useEffect(() => {
    // Push a dummy state so the first Back triggers popstate here
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      resetFormData();
      navigate("/step1", { replace: true, state: {} });
    };

    window.addEventListener("popstate", handleBack);
    return () => window.removeEventListener("popstate", handleBack);
  }, [navigate, resetFormData]);

  return (
    <div className="container mt-5">
      <section className="vip-levels container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="confirm-card text-center">
              {/* Icon + heading */}
              <div className="mx-auto mb-3">
                <img
                  src="https://vsga.org/hubfs/VSGA_Logo_Glossy-for-site.png"
                  className="img img-fluid"
                  alt="VSGA Logo"
                  style={{ maxWidth: 120 }}
                />
              </div>

              <h2 className="mb-2 heading">Thank you for your purchase!</h2>

              <p className="lead text-muted mb-4">
                Your {formData.GiftPurchase ? "gift" : "VIP Card"} order has
                been received and is being processed.
              </p>

              {/* Transaction details */}
              <div className="confirm-summary mb-4">
                {golfer?.product_id && (
                  <p className="mb-1">
                    <span className="text-muted">
                      Order / Transaction&nbsp;ID:
                    </span>{" "}
                    <span className="fw-semibold">
                      {golfer.versapayTransactionId}
                    </span>
                  </p>
                )}
              </div>

              {/* Digital card “getting started” message */}
              {golfer?.vip_card_type === "digital" && (
                <div className="alert alert-light text-start text-md-center mx-auto mb-4">
                  <h6 className="mb-1 fw-semibold">
                    You chose the Digital VIP Card
                  </h6>
                  <p className="mb-0 small">
                    Check your email for next steps. You’ll receive a
                    confirmation with instructions on how to access your digital
                    VIP Card and start using your benefits right away.
                  </p>
                </div>
              )}

              {/* Gift-specific message */}
              {formData.GiftPurchase && (
                <div className="alert alert-success text-start text-md-center confirm-gift-alert mx-auto mb-4">
                  <h6 className="mb-1 fw-semibold">This purchase is a gift</h6>
                  <p className="mb-0 small">
                    Your gift order will generate a promo code and gift
                    certificate for the recipient. Keep an eye on your inbox for
                    the details and redemption instructions.
                  </p>
                </div>
              )}

              {/* Tiny footer note */}
              <p className="text-muted small mb-0">
                Didn’t receive an email within a few minutes? Please check your
                spam folder or contact us for help.
              </p>

              <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
                <button
                  className="btn btn-primary px-4"
                  onClick={() => {
                    resetFormData();
                    navigate("/step1", { state: {} });
                  }}
                >
                  Start New Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Confirm;